var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ofertas"},[_c('div',{staticClass:"contenedor-ofertas"},_vm._l((_vm.ofertas.slice(0,5)),function(oferta,key){return _c('oferta',{key:key,attrs:{"data":oferta}})}),1),_vm._v(" "),_c('router-link',{staticClass:"link",attrs:{"to":_vm.$t('enlaces.ofertas')}},[_vm._v("Ver más")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-764958f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/home/ofertas.vue
// module id = null
// module chunks = 